import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  // TODO Purpose of the following code is only for an example!
  // Remove once not needed.

  title = 'angular';
  init = false;

  switchInit(): void {
    this.init = !this.init;
  }

  showMessage(): boolean {
    return this.init;
  }
}
